import { api } from '~shared/api/origin';

export const locationApi = api.injectEndpoints({
	endpoints: (build) => ({
		getLocation: build.query<{ country: string }, unknown>({
			query: () => ({
				url: '/location',
			}),
		}),
	}),
});
